import { extractUuid } from './uuid';

/**
 * Config id of an advanced format widget.
 *
 * Widgets now store the selected game uuid in `configId`, but widgets configured before the game
 * picker existed only have a `configUrl` containing that uuid, so both are accepted.
 */
export function resolveAdvancedFormatConfigId(
  attributes: { configId?: unknown; configUrl?: unknown } | null | undefined,
): string | undefined {
  for (const candidate of [attributes?.configId, attributes?.configUrl]) {
    if (typeof candidate !== 'string' || !candidate.trim()) {
      continue;
    }
    try {
      return extractUuid(candidate);
    } catch {
      // not a uuid nor a url containing one, fall through to the next candidate
    }
  }
  return undefined;
}
